var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKruglik(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 162,
    viewBox: "0 0 135 162",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M92.5938 122.836C90.0605 121.735 85.4156 120.103 79.4283 120.225C74.1081 120.332 69.9543 121.776 67.5152 122.836C70.7441 124.657 73.969 126.483 77.1979 128.304L92.5938 122.836Z",
    fill: "#1E1E1E",
    stroke: "#1E1E1E",
    strokeWidth: 1.94094,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8603 136.467H84.4215C86.1321 125.921 87.409 113.336 87.3517 99.1518C87.2985 85.7122 86.0625 73.7499 84.4215 63.6211H72.8603C74.5587 72.5508 75.9051 83.0357 76.2243 94.7851C76.6622 111.028 75.0088 125.159 72.8603 136.471V136.467Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.94094,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0308 122.836C36.564 121.735 41.209 120.103 47.1962 120.225C52.5164 120.332 56.6703 121.776 59.1094 122.836C55.8804 124.657 52.6556 126.483 49.4266 128.304L34.0308 122.836Z",
    fill: "#1E1E1E",
    stroke: "#1E1E1E",
    strokeWidth: 1.94094,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7617 136.467H42.2005C40.4899 125.921 39.213 113.336 39.2703 99.1518C39.3235 85.7122 40.5595 73.7499 42.2005 63.6211H53.7617C52.0634 72.5508 50.7169 83.0357 50.3977 94.7851C49.9598 111.028 51.6132 125.159 53.7617 136.471V136.467Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.94094,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M85.3405 69.4727L86.1426 76.5812L75.4572 81.9997L74.5773 72.6075L85.3405 69.4727Z",
    fill: "#1E1E1E",
    stroke: "#1E1E1E",
    strokeWidth: 1.94094,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M41.112 69.998L40.3099 77.1066L50.9912 82.525L51.8711 73.1329L41.112 69.998Z",
    fill: "#1E1E1E",
    stroke: "#1E1E1E",
    strokeWidth: 1.94094,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M92.5904 122.84C89.9426 123.72 86.3617 124.608 82.0728 124.825C75.8277 125.144 70.749 123.912 67.516 122.84C66.6811 135.379 65.8422 147.918 65.0073 160.454H105.756C105.465 155.657 102.883 151.475 98.9296 149.621C95.848 148.176 92.9015 148.598 91.6492 148.856C91.9643 140.184 92.2753 131.512 92.5904 122.84Z",
    fill: "#5B5BD8",
    stroke: "#1E1E1E",
    strokeWidth: 1.94094,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0341 122.84C36.6819 123.72 40.2628 124.608 44.5517 124.825C50.7967 125.144 55.8755 123.912 59.1085 122.84C59.9434 135.379 60.7823 147.918 61.6172 160.454H20.8686C21.1592 155.657 23.7415 151.475 27.6948 149.621C30.7765 148.176 33.723 148.598 34.9753 148.856C34.6602 140.184 34.3492 131.512 34.0341 122.84Z",
    fill: "#5B5BD8",
    stroke: "#1E1E1E",
    strokeWidth: 1.94094,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8525 78.6723C43.3096 78.6723 26.6562 64.0638 26.6562 46.0432C26.6562 28.0226 43.3096 13.4141 63.8525 13.4141C84.3955 13.4141 101.049 28.0226 101.049 46.0432C101.049 64.0638 84.3955 78.6723 63.8525 78.6723Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.94094,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9829 34.6152H86.0288C89.5909 34.6152 92.4785 37.5029 92.4785 41.0649V41.069C92.4785 44.6311 89.5909 47.5187 86.0288 47.5187H43.9829C40.4209 47.5187 37.5332 44.6311 37.5332 41.069V41.0649C37.5332 37.5029 40.4209 34.6152 43.9829 34.6152Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.94094,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M36.643 18.6932C36.643 11.1803 42.7334 5.08984 50.2463 5.08984C57.7592 5.08984 63.8496 11.1803 63.8496 18.6932V21.1486C63.8496 28.6615 57.7592 34.7519 50.2463 34.7519C42.7334 34.7519 36.643 28.6615 36.643 21.1486V18.6932Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.94094,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9322 27.8683C45.5487 27.8683 42.8058 23.9711 42.8058 19.1636C42.8058 14.3562 45.5487 10.459 48.9322 10.459C52.3157 10.459 55.0586 14.3562 55.0586 19.1636C55.0586 23.9711 52.3157 27.8683 48.9322 27.8683Z",
    fill: "#1E1E1E",
    stroke: "#1E1E1E",
    strokeWidth: 1.94094,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0044 7.83984L48.6676 14.7233L56.6602 13.4097L51.0044 7.83984Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8442 18.6932C63.8442 11.1803 69.9346 5.08984 77.4475 5.08984C84.9604 5.08984 91.0508 11.1803 91.0508 18.6932V21.1486C91.0508 28.6615 84.9604 34.7519 77.4475 34.7519C69.9346 34.7519 63.8442 28.6615 63.8442 21.1486V18.6932Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.94094,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M76.1412 27.8683C72.7577 27.8683 70.0148 23.9711 70.0148 19.1636C70.0148 14.3562 72.7577 10.459 76.1412 10.459C79.5247 10.459 82.2676 14.3562 82.2676 19.1636C82.2676 23.9711 79.5247 27.8683 76.1412 27.8683Z",
    fill: "#1E1E1E",
    stroke: "#1E1E1E",
    strokeWidth: 1.94094,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M78.2136 7.83984L75.8768 14.7233L83.8652 13.4097L78.2136 7.83984Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M86.9766 41.0664H43.5843",
    stroke: "#1E1E1E",
    strokeWidth: 1.94094,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2702 43.8613L20.4608 50.266V32.6848C24.9379 31.8909 27.8476 27.9253 27.3688 24.1439C27.0046 21.2628 24.7087 18.7623 21.5903 17.866C21.6312 15.7584 21.7867 2.87947 17.6984 1.16064C17.4774 1.06651 17.0763 0.902812 16.5893 1.00103C13.4913 1.62718 13.299 11.6128 13.2785 13.4012C9.60349 16.27 5.92847 19.1388 2.25345 22.0076C2.28619 23.219 2.499 25.2079 3.50983 27.4096C4.81123 30.2334 6.75105 31.9113 7.77826 32.6848C7.38948 41.8396 7.46723 49.6276 7.67595 55.668C7.90922 62.4369 8.21615 64.5896 9.78765 65.9687C15.4557 70.937 31.4858 60.5299 33.9004 58.9338",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2702 43.8613L20.4608 50.266V32.6848C24.9379 31.8909 27.8476 27.9253 27.3688 24.1439C27.0046 21.2628 24.7087 18.7623 21.5903 17.866C21.6312 15.7584 21.7867 2.87947 17.6984 1.16064C17.4774 1.06651 17.0763 0.902812 16.5893 1.00103C13.4913 1.62718 13.299 11.6128 13.2785 13.4012C9.6035 16.27 5.92847 19.1388 2.25345 22.0076C2.28619 23.219 2.499 25.2079 3.50983 27.4096C4.81123 30.2334 6.75105 31.9113 7.77826 32.6848C7.38948 41.8396 7.46723 49.6276 7.67595 55.668C7.90922 62.4369 8.21615 64.5896 9.78766 65.9687C15.4557 70.937 31.4858 60.5299 33.9004 58.9338",
    stroke: "#1E1E1E",
    strokeWidth: 1.94094,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6998 24.5182C18.1748 25.5618 15.7889 25.0298 14.9336 23.6383C14.1969 22.4392 14.8067 20.9455 14.8885 20.7491C15.7357 18.7601 18.4081 17.5856 21.5879 17.8598",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6998 24.5182C18.1748 25.5618 15.7889 25.0298 14.9336 23.6383C14.1969 22.4392 14.8067 20.9455 14.8885 20.7491C15.7357 18.7601 18.4081 17.5856 21.5879 17.8598",
    stroke: "#1E1E1E",
    strokeWidth: 1.94094,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7463 25.0675C8.94719 25.0675 7.48872 22.0736 7.48872 18.3804C7.48872 14.6873 8.94719 11.6934 10.7463 11.6934C12.5454 11.6934 14.0039 14.6873 14.0039 18.3804C14.0039 22.0736 12.5454 25.0675 10.7463 25.0675Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.94094,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M4.22874 25.0704C2.42962 25.0704 0.971149 22.639 0.971149 19.6397C0.971149 16.6404 2.42962 14.209 4.22874 14.209C6.02786 14.209 7.48633 16.6404 7.48633 19.6397C7.48633 22.639 6.02786 25.0704 4.22874 25.0704Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.94094,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M89.5591 62.02C93.9462 63.1782 102.941 66.2639 109.87 74.6575C112.035 77.2808 113.574 79.9041 114.674 82.2368C110.783 87.205 110.512 92.1528 112.309 93.577C113.803 94.7597 117.122 93.8266 120.183 91.6494C126.096 93.3314 131.278 92.9099 133.123 90.1966C133.676 89.3822 135.161 86.5502 129.898 77.8865C125.74 71.0439 116.451 59.0407 94.7074 47.1562",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M89.5591 62.02C93.9462 63.1782 102.941 66.2639 109.87 74.6575C112.035 77.2808 113.574 79.9041 114.674 82.2368C110.783 87.205 110.512 92.1528 112.309 93.577C113.803 94.7597 117.122 93.8266 120.183 91.6494C126.096 93.3314 131.278 92.9099 133.123 90.1966C133.676 89.3822 135.161 86.5502 129.898 77.8865C125.74 71.0439 116.451 59.0407 94.7074 47.1562",
    stroke: "#1E1E1E",
    strokeWidth: 1.94094,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M124.226 88.1875C126.882 92.3577 127.557 96.6916 126.387 98.5987C125.859 99.4581 124.963 99.8101 124.173 99.675C122.098 99.3231 119.945 95.4721 119.283 89.9841",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M124.226 88.1875C126.882 92.3577 127.557 96.6916 126.387 98.5987C125.859 99.4581 124.963 99.8101 124.173 99.675C122.098 99.3231 119.945 95.4721 119.283 89.9841",
    stroke: "#1E1E1E",
    strokeWidth: 1.94094,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M128.899 86.3848C129.271 86.9904 129.664 87.723 130.016 88.5783C130.479 89.7119 130.745 90.7514 130.904 91.6067",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M128.899 86.3848C129.271 86.9904 129.664 87.723 130.016 88.5783C130.479 89.7119 130.745 90.7514 130.904 91.6067",
    stroke: "#1E1E1E",
    strokeWidth: 1.94094,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6172 57.5421C57.8439 52.8399 52.7038 50.9287 49.8391 52.4593C45.4234 54.8206 45.6689 65.7843 50.5348 67.9615C53.5182 69.2956 58.29 67.3476 61.6172 62.9482V57.5421Z",
    fill: "#5B5BD8",
    stroke: "#1E1E1E",
    strokeWidth: 1.94094,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M66.0763 57.5421C69.8495 52.8399 74.9897 50.9287 77.8544 52.4593C82.2701 54.8206 82.0246 65.7843 77.1587 67.9615C74.1753 69.2956 69.4035 67.3476 66.0763 62.9482V57.5421Z",
    fill: "#5B5BD8",
    stroke: "#1E1E1E",
    strokeWidth: 1.94094,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4849 64.5243C61.0733 64.5243 59.1183 62.5693 59.1183 60.1577C59.1183 57.746 61.0733 55.791 63.4849 55.791C65.8965 55.791 67.8516 57.746 67.8516 60.1577C67.8516 62.5693 65.8965 64.5243 63.4849 64.5243Z",
    fill: "#5B5BD8",
    stroke: "#1E1E1E",
    strokeWidth: 1.94094,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKruglik);
export default __webpack_public_path__ + "static/media/kruglik.36aab502c68d7b348bf2fd51e6643d96.svg";
export { ForwardRef as ReactComponent };